import type { ReactNode } from "react";

type Props = {
  title?: ReactNode;
  left?: ReactNode;
  right?: ReactNode;
  sub?: ReactNode;
};

/**
 * TopBar — page header. Title slot accepts string or any element (e.g. Logo).
 */
export function TopBar({ title, left, right, sub }: Props) {
  return (
    <div className="relative z-[5] px-5 pt-3.5 pb-2 lg:pt-6">
      <div className="flex justify-between items-center min-h-[32px]">
        <div>{left}</div>
        {title ? (
          typeof title === "string" ? (
            <h1 className="display m-0" style={{ fontSize: 22 }}>
              {title}
            </h1>
          ) : (
            title
          )
        ) : null}
        <div>{right}</div>
      </div>
      {sub && (
        <div className="mt-1" style={{ color: "var(--color-text-muted)", fontSize: 13 }}>
          {sub}
        </div>
      )}
    </div>
  );
}
